import { Injectable } from '@angular/core';
import { TakealotVoucher } from '../models/interfaces';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DatabaseService } from './database.service';
import { UserChangeService } from './user-change.service';


@Injectable({
  providedIn: 'root'
})
export class TakealotVouchersService {
  userTakealotVouchers$:BehaviorSubject<TakealotVoucher[]> = new BehaviorSubject([])
  private _takealotVouchers:TakealotVoucher[] = []
  get takealotVouchers(){
    return this._takealotVouchers
  }
  private takealotVouchersSubscription:Subscription
  constructor(
    private database: DatabaseService,
    private userChangeService:UserChangeService
  ) { 
    this.userChangeService.user$.subscribe((userId) => {
      if(!userId) return;
      this.listenToUserTakealotVouchers(true);
    });
  }

  async listenToUserTakealotVouchers(force=false){
    if(force && this.takealotVouchersSubscription){
      this.takealotVouchersSubscription.unsubscribe();
    }
    if(!this.takealotVouchersSubscription||this.takealotVouchersSubscription.closed){
      this.database.listenToUserTakealotVouchers(this.userTakealotVouchers$);
      this.takealotVouchersSubscription = this.userTakealotVouchers$.subscribe((takealotVouchers)=>{
        this._takealotVouchers = takealotVouchers
      })
    }else{
      console.log('Already listening. subscribe to the active subject instead');
    }
  }
}
